/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PersonTypeDTO = {
    guest: 'guest',
    crew: 'crew'
} as const;
export type PersonTypeDTO = typeof PersonTypeDTO[keyof typeof PersonTypeDTO];

